import { render, staticRenderFns } from "./TradersFeesBlock.vue?vue&type=template&id=0f233e8a&scoped=true&"
import script from "./TradersFeesBlock.vue?vue&type=script&lang=js&"
export * from "./TradersFeesBlock.vue?vue&type=script&lang=js&"
import style0 from "./TradersFeesBlock.vue?vue&type=style&index=0&id=0f233e8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f233e8a",
  null
  
)

export default component.exports